import React from "react";
import { useNavigate } from "react-router-dom";
import "./print-button.css";

const PrintViewButton = ({ organizationId, protocolId }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/printable-plan/${organizationId}/${protocolId}`);
  };

  return (
    <button className="print-view-button" onClick={handleClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="18"
        height="18"
        fill="currentColor"
        style={{ marginRight: "8px" }}
      >
        <path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z" />
      </svg>
      Printable Version
    </button>
  );
};

export default PrintViewButton;
